import { useCallback } from 'react'
import { TableWithoutVirtualListingRowRenderer } from '../../../baseComponents/TwinTable/TableWithoutVirtualListing/types'
import { useOrderTableRender } from '../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/useOrderTableHooks'
import { OrderData } from '../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import { TableWithoutDefaultRowRenderer } from '../../../baseComponents/TwinTable/TableWithoutVirtualListing'

interface OrderRowRendererProps {
    completeData: OrderData | null
    isFinishedStep?: boolean
}

const useOrderRowRenderer = ({ completeData, isFinishedStep }: OrderRowRendererProps) => {
    const { addCombinedHeaderFinalized, addExtraProps } = useOrderTableRender({ completeData: completeData || { header: {}, tableData: [], originalTableData: [], dictPosTableData: {}, filters: { generalSearchbar: '', order: {}, singleFieldsSearch: {} }} })
    const rowRenderer: TableWithoutVirtualListingRowRenderer = useCallback((props) => {
        if (isFinishedStep) {
            props.rowData['finishedStep'] = true
        }
        if (props?.rowData?.type === 'productCombinedHeader') {
            return addCombinedHeaderFinalized(props)
        } else if (props?.rowData?.type === 'productCombinedHeaderAddon') {
            if (props.rowData['Product.ProductVariantGroupId']) {
                props.className += ' row_productcombined_variant'
            }
            const { className } = addExtraProps(props)
            return <TableWithoutDefaultRowRenderer {...props} className={(className || '') + ' product_combined_addon_header'} key={'productCombinedHeaderAddon' + props.rowData.id + props.rowData.FirstChildId} />
        }
        const { className } = addExtraProps(props)
        return <TableWithoutDefaultRowRenderer {...props} className={className} key={props.rowData?.id || props.rowIndex} />
    }, [addCombinedHeaderFinalized, addExtraProps, isFinishedStep])

    return rowRenderer
}

export default useOrderRowRenderer